import "./App.css";
import React, { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import Contract1 from "./Contract1";
import Contract2 from "./Contract2";
import Contract3 from "./Contract3";
import Contract4 from "./Contract4";
import Contract5 from "./Contract5";
import Termsheet from "./Termsheet";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import EULA from "./EULA";
import EDAgreement from "./EDAgreement";
import Home from "./Home";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/official",
      element: <Contract1 />,
    },
    {
      path: "/promo",
      element: <Contract2 />,
    },
    {
      path: "/ged",
      element: <Contract3 />,
    },
    {
      path: "/AcknowledgementLetter",
      element: <Contract4 />,
    },
    {
      path: "/promo-002",
      element: <Contract5 />,
    },
    // {
    //   path: "/termsheet",
    //   element: <Termsheet />,
    // },
    // {
    //   path: "/termsheet/:id",
    //   element: <Termsheet />,
    // },
    {
      path: "/ed-agreement",
      element: <EDAgreement />,
    },
    // {
    //   path: "/EULA",
    //   element: <EULA />,
    // },
  ]);

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
}

export default App;
